const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`, `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`, 1, 65), undefined, true, false, 1));
            }

            getTemplateName() {
                return `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`;
            }

            getSourceContext() {
                return new this.Source(``, `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`, ``);
            }
        }],
        [65, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <iframe height="300" style="width: 100%;" scrolling="no" title="Staggered Menu Transition" src="https://codepen.io/tylersticka/embed/rWKVrj?height=300&theme-id=28494&default-tab=css,result">
      See the Pen <a href='https://codepen.io/tylersticka/pen/rWKVrj'>Staggered Menu Transition</a> by Tyler Sticka
      (<a href='https://codepen.io/tylersticka'>@tylersticka</a>) on <a href='https://codepen.io'>CodePen</a>.
    </iframe>
  `);
            }

            getTemplateName() {
                return `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec');

let template = env.loadTemplate('87fff079bb3b6e24cc61047dd6ed8110cc80abada7f087a55d839aebbf46dbec');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/embed/demo/pen.twig", args: context }
     );
     return rendered;;
};